import { ref } from 'vue';
import type { ToastType } from '@/types';

/**
 * Mini-toast inline (notification dans le panel itinéraire).
 *
 * État partagé entre toutes les instances (singleton). Un seul toast affiché à la fois,
 * timer de 3s. Suffisant pour les retours "lien copié", "exporté", erreurs légères.
 */

interface ToastData {
  visible: boolean;
  msg: string;
  type: ToastType;
}

const toastData = ref<ToastData>({
  visible: false,
  msg: '',
  type: 'success',
});

let timer: ReturnType<typeof setTimeout> | null = null;

export function useToast() {
  function show(msg: string, type: ToastType = 'success'): void {
    toastData.value = { visible: true, msg, type };
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      toastData.value.visible = false;
    }, 3000);
  }

  return { toast: toastData, show };
}
